// Pure composition of the one-time, remembered widget-signing consent
// flow. Kept free of React and localStorage so the decision logic is
// unit-testable; the hook injects the real store + dialog requester.

export interface EnsureConsentDeps {
  /** True when a remembered grant already exists. */
  isGranted: () => boolean;
  /** Persist the grant after the user approves. */
  grant: () => void;
  /** Open the consent dialog; resolves true on approve, false otherwise. */
  requestConsent: () => Promise<boolean>;
}

/**
 * Build the `ensureSignConsent` callback the bridge awaits before signing.
 * Short-circuits to `true` on an existing grant (no prompt), otherwise
 * prompts and persists only on approval.
 */
export function buildEnsureSignConsent(deps: EnsureConsentDeps): () => Promise<boolean> {
  return async () => {
    if (deps.isGranted()) return true;
    const approved = await deps.requestConsent();
    if (approved) deps.grant();
    return approved;
  };
}
